import React, { useCallback, useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { makeStyles, Button, Typography } from "../../../../index";
import { useTranslation } from "../../../../hooks/useTranslation";
import { ImageEditorContainer } from "./ImageEditorContainer";
import { ROTATE_BUTTON_MARGIN } from "../constants/upload-image";
var ACCEPT_EXTENSIONS = ['.jpeg', '.jpg', '.png', '.gif'];
var ACCEPT_TYPES = ['image/jpeg', 'image/png', 'image/gif'];
var useStyles = makeStyles(function (theme) { return ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        background: theme.palette.light.background.default,
        overflow: 'hidden',
        flex: 1,
    },
    text: {
        pointerEvents: 'none',
        fontSize: 18,
        marginBottom: theme.spacing(2),
    },
    fileInput: {
        display: 'none',
    },
    fileDropArea: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderWidth: 2,
        borderStyle: 'dashed',
        borderColor: theme.palette.light.text.hint,
        width: "calc(100% - " + theme.spacing(3) + "px * 2)",
        height: "calc(100% - " + theme.spacing(3) + "px * 2)",
        margin: theme.spacing(3),
        flex: 1,
    },
    dragOver: {
        background: '#a9c0e7',
        borderColor: '#3a7fea',
    },
}); });
export var UploadImage = function (props) {
    var _a;
    var isIcon = props.isIcon, onChangeImageDataUrl = props.onChangeImageDataUrl;
    var _b = useState(false), dragOver = _b[0], setDragOver = _b[1];
    var _c = useState(), imageDataUrl = _c[0], setImageDataUrl = _c[1];
    var _d = useState(''), imageType = _d[0], setImageType = _d[1];
    var _e = useState({ width: 0, height: 0 }), imageSize = _e[0], setImageSize = _e[1];
    var classes = useStyles();
    var fileInput = useRef(null);
    var imageEditingArea = useRef(null);
    var t = useTranslation().t;
    var updateImageArea = function () {
        var _a;
        var rect = (_a = imageEditingArea.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        // imageSizeの幅は、両側に回転ボタンが入るだけのマージンを確保する必要がある
        if (rect) {
            setImageSize({
                width: Math.max(rect.right - rect.left - ROTATE_BUTTON_MARGIN * 2, 0),
                height: rect.bottom - rect.top,
            });
        }
    };
    useEffect(function () {
        var onResize = updateImageArea;
        onResize();
        window.addEventListener('resize', onResize);
        return function () {
            window.removeEventListener('resize', onResize);
        };
    }, [imageDataUrl]);
    var handleSelectFile = useCallback(function (file) {
        var reader = new FileReader();
        reader.onload = function () {
            updateImageArea();
            setImageDataUrl(reader.result);
            setImageType(file.type);
            onChangeImageDataUrl === null || onChangeImageDataUrl === void 0 ? void 0 : onChangeImageDataUrl(reader.result);
        };
        reader.readAsDataURL(file);
    }, [onChangeImageDataUrl]);
    var handleDragOver = useCallback(function (e) {
        e.preventDefault();
        setDragOver(true);
    }, []);
    var handleDragLeave = useCallback(function (e) {
        e.preventDefault();
        setDragOver(false);
    }, []);
    var handleDrop = useCallback(function (e) {
        e.preventDefault();
        var files = e.dataTransfer.files;
        if (!files || files.length !== 1 || !ACCEPT_TYPES.includes(files[0].type)) {
            setDragOver(false);
            return;
        }
        handleSelectFile(files[0]);
    }, [handleSelectFile]);
    var handleClickFileInput = useCallback(function () {
        var _a;
        (_a = fileInput.current) === null || _a === void 0 ? void 0 : _a.click();
    }, [fileInput]);
    var handleChangeFileInput = useCallback(function () {
        var _a;
        var files = (_a = fileInput.current) === null || _a === void 0 ? void 0 : _a.files;
        if (!files || files.length !== 1 || !ACCEPT_TYPES.includes(files[0].type)) {
            return;
        }
        handleSelectFile(files[0]);
    }, [handleSelectFile]);
    var handleErrorImageLoading = useCallback(function () {
        setImageDataUrl(undefined);
        setDragOver(false);
        onChangeImageDataUrl === null || onChangeImageDataUrl === void 0 ? void 0 : onChangeImageDataUrl(undefined);
    }, [onChangeImageDataUrl]);
    return (React.createElement("div", { className: classes.root, ref: imageEditingArea },
        imageDataUrl ? (React.createElement(ImageEditorContainer, { isIcon: isIcon, editorMaxWidth: imageSize.width, editorMaxHeight: imageSize.height, imageDataUrl: imageDataUrl, imageType: imageType, changeButtonLabel: t('変更'), onChangeImageDataUrl: onChangeImageDataUrl, onChangeButtonClick: handleClickFileInput, onErrorImageLoading: handleErrorImageLoading })) : (React.createElement("div", { className: classNames(classes.fileDropArea, (_a = {}, _a[classes.dragOver] = dragOver, _a)), onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDrop },
            React.createElement(Typography, { className: classes.text }, t('ここにファイルをドラッグ')),
            React.createElement(Typography, { className: classes.text }, t('または')),
            React.createElement(Button, { fill: true, variant: "dialog", onClick: handleClickFileInput }, t('ファイルを選ぶ')))),
        React.createElement("input", { type: "file", accept: ACCEPT_EXTENSIONS.join(), className: classes.fileInput, ref: fileInput, onChange: handleChangeFileInput })));
};
